import React from "react";
import { getIdentite, saveIdentite } from "../../actions/identite";
import { connect } from "react-redux";
import { getDomain, tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";

class AdminIdentite extends React.Component {
    state = {
        menuActive: false,
        opts: [],
        form: {
            logo: null,
            logoRes: null,
            name: null,
            desc: null
        },
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.props.getIdentite();
            this.setState({
                alert: tempAlWait()
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.getIdentite();
                this.setState({
                    alert: tempAlWait()
                })
            }
        }

        if (prevProps.redSaveIdtt != this.props.redSaveIdtt) {
            this.setState({
                alert: this.props.redSaveIdtt.alert
            })
        }
        if (prevProps.redGetIdtt != this.props.redGetIdtt) {
            if (this.props.redGetIdtt.alert.type == "succ") {
                this.setState({
                    alert: this.props.redGetIdtt.alert,
                    form: {
                        logo: null,
                        logoRes: this.props.redGetIdtt.datas.logo,
                        name: this.props.redGetIdtt.datas.name,
                        desc: this.props.redGetIdtt.datas.desc
                    }
                })
            } else {
                this.setState({
                    alert: this.props.redGetIdtt.alert
                })
            }
        }
    }

    handleSave(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        });
        this.props.saveIdentite({
            logo: this.state.form.logo,
            name: this.state.form.name,
            desc: this.state.form.desc
        });
    }

    getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = "";

            let reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            }
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Modifier l'identité du site"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Nom du site **/}
                    <div className="admin__inpgrp" title="Nom du site" aria-label="Nom du site">
                        <label htmlFor="idtt-name" className="admin__lab">
                            Nom du site *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Nom du site"
                            className="admin__input"
                            id="idtt-name"
                            value={this.state.form.name}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        name: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>
                    {/** Description **/}
                    <div className="admin__inpgrp" title="Description de ta chaine" aria-label="Description de ta chaine">
                        <label htmlFor="idtt-desc" className="admin__lab">
                            Description *
                        </label>
                        <textarea
                            required
                            placeholder="Description de ta chaine"
                            className="admin__input admin__input--txtarea" 
                            id="idtt-desc"
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        desc: el.target.value
                                    }
                                }))
                            }}
                            value={this.state.form.desc}></textarea>
                    </div>

                    {/** Logo **/}
                    <div className="admin__inpgrp admin__inpgrp--img" title="Logo" aria-label="Logo">
                        <label htmlFor="idtt-logo" className="admin__lab">
                            Logo
                        </label>
                        <input
                            type="file"
                            accept="image/*"
                            className="admin__input"
                            id="idtt-logo"
                            onChange={(el) => {
                                this.getBase64(el.target.files[0])
                                    .then(result => {
                                        el.target.files[0]["base64"] = result;

                                        this.setState(
                                            prevState => ({
                                                form: {
                                                    ...prevState.form,
                                                    logo: result
                                                }
                                            })
                                        )
                                    })
                                    .catch(err => {console.log(err)})
                            }}
                        />
                        {
                            this.state.form.logo == null ?
                                (this.state.form.logoRes != null ?
                                    <img src={`${getDomain()}image/logo/${this.state.form.logoRes}`} alt="Image en cours de chargement" className="admin__inpimg" />  :
                                    <div></div>) :
                                    <img src={this.state.form.logo} alt="Image en cours de chargement" className="admin__inpimg" /> 
                        }
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Modifier l'identité du site"
                        aria-label="Modifier l'identité du site"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSave(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Modifier</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert}/>
        </main> 
    }
}

const mapStateToProps = state => {
    return {
        redSaveIdtt: state.redSaveIdtt,
        redGetIdtt: state.redGetIdtt
    }
}

const mapDispatchToProps = {
    saveIdentite,
    getIdentite
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminIdentite);